import React from 'react';
import PropTypes from 'prop-types';
import * as qs from 'qs';

class PaymentCallback extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
  };

  componentDidMount() {
    if (window.opener) {
      window.opener.postMessage({
        action: 'paymentCallbackReceived',
        parsedQuery: qs.parse(this.props.location.search, { ignoreQueryPrefix: true }),
      }, `${window.location.origin}`);
    } else {
      window.parent.postMessage({
        action: 'paymentCallbackReceived',
        parsedQuery: qs.parse(this.props.location.search, { ignoreQueryPrefix: true }),
      }, `${window.location.origin}`);
    }
  }

  // eslint-disable-next-line
  render() {
    return null;
  }
}

export default PaymentCallback;



// WEBPACK FOOTER //
// ./src/app/components/PaymentCallback/index.js